import { render, staticRenderFns } from "./BasePDFRenderExam.vue?vue&type=template&id=6fa7c063&scoped=true&"
import script from "./BasePDFRenderExam.vue?vue&type=script&lang=js&"
export * from "./BasePDFRenderExam.vue?vue&type=script&lang=js&"
import style0 from "./BasePDFRenderExam.vue?vue&type=style&index=0&id=6fa7c063&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7c063",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fa7c063')) {
      api.createRecord('6fa7c063', component.options)
    } else {
      api.reload('6fa7c063', component.options)
    }
    module.hot.accept("./BasePDFRenderExam.vue?vue&type=template&id=6fa7c063&scoped=true&", function () {
      api.rerender('6fa7c063', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BasePDFRenderExam.vue"
export default component.exports